const YM_ID = 89712042;

export default class yandexMetrika {
  /**
   * @param {String} action
   * @param {Object} params
   * @param {String} event
   *
   * @returns {boolean}
   */
  static invokeEvent(target) {
    if (typeof window === 'undefined') {
      return false;
    }

    if (!(window.ym instanceof Function)) {
      console.warn('yandexMetrikaAnalytics: ym function is not defined');
      return false;
    }

    /**
     * @param {Function} window.ym
     */
    window.ym(YM_ID, 'reachGoal', target);

    return true;
  }
}
